(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const headerElement = document.getElementById('shopify-section-header'),
      headerHeight = headerElement.clientHeight,
      headerHeightWithoutBottomNav = headerElement.querySelector('.header_wrapper').clientHeight;

    document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
    document.documentElement.style.setProperty('--header-height-without-bottom-nav', headerHeightWithoutBottomNav + 'px');
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["proefrit-planner"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.proefrit-planner-embed').forEach(function (el) {
  if (el.dataset.calInitialized) return;
  el.dataset.calInitialized = 'true';

  var calLink = el.getAttribute('data-cal-link');
  var origin = el.getAttribute('data-cal-origin');
  var embedScript = el.getAttribute('data-cal-embed-script');
  var namespace = el.getAttribute('data-cal-namespace');
  var brandColor = el.getAttribute('data-cal-brand-color') || '#2197d3';

  if (!calLink || !origin || !embedScript || !namespace) return;

  (function (C, A, L) {
    var p = function (a, ar) { a.q.push(ar); };
    var d = C.document;
    C.Cal = C.Cal || function () {
      var cal = C.Cal;
      var ar = arguments;
      if (!cal.loaded) {
        cal.ns = {};
        cal.q = cal.q || [];
        d.head.appendChild(d.createElement('script')).src = A;
        cal.loaded = true;
      }
      if (ar[0] === L) {
        var api = function () { p(api, arguments); };
        var ns = ar[1];
        api.q = api.q || [];
        if (typeof ns === 'string') {
          cal.ns[ns] = cal.ns[ns] || api;
          p(cal.ns[ns], ar);
          p(cal, ['initNamespace', ns]);
        } else {
          p(cal, ar);
        }
        return;
      }
      p(cal, ar);
    };
  })(window, embedScript, 'init');

  window.Cal('init', namespace, { origin: origin });

  var today = new Date();
  var daysUntilSaturday = (6 - today.getDay() + 7) % 7;
  today.setDate(today.getDate() + daysUntilSaturday);
  var dateStr = today.getFullYear() + '-' +
    String(today.getMonth() + 1).padStart(2, '0') + '-' +
    String(today.getDate()).padStart(2, '0');

  window.Cal.ns[namespace]('inline', {
    elementOrSelector: '#' + el.id,
    config: { layout: 'month_view', date: dateStr },
    calLink: calLink
  });

  window.Cal.ns[namespace]('ui', {
    theme: 'light',
    cssVarsPerTheme: {
      light: { 'cal-brand': brandColor },
      dark: { 'cal-brand': brandColor }
    },
    hideEventTypeDetails: false,
    layout: 'month_view'
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-slider"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.reviews-slider-section').forEach(function (root) {
  var track = root.querySelector('[data-track]');
  var prevBtn = root.querySelector('[data-prev]');
  var nextBtn = root.querySelector('[data-next]');
  if (!track) return;

  function cardStep() {
    var card = track.querySelector('.reviews-slider-card');
    if (!card) return 300;
    var style = window.getComputedStyle(track);
    var gap = parseInt(style.columnGap || style.gap || '20', 10) || 20;
    return card.getBoundingClientRect().width + gap;
  }

  if (prevBtn) {
    prevBtn.addEventListener('click', function () {
      track.scrollBy({ left: -cardStep(), behavior: 'smooth' });
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', function () {
      track.scrollBy({ left: cardStep(), behavior: 'smooth' });
    });
  }
});

  } catch(e) { console.error(e); }
})();
})();
